export default __webpack_public_path__ + "static/media/x-ixon.5fe23318.svg";